import React, { Component } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { Link } from "react-router-dom";
import { navigate } from "../../store/navigation/operations";
import { Navbar, Drawer, Icon } from "@blueprintjs/core";
import MainNavItems from "../../components/MainNavItems";
import LanguageSelector from "../../components/LanguageSelector";
import Login from "../auth/Login";
import Register from "../auth/Register";
import CustomIcon from "../../components/CustomIcon";
import { Translate } from "react-redux-i18n";
import ReactGA from "react-ga";

export class PublicTopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false,
      showLoginDialog: false,
      showRegisterForm: false,
    };
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.hideLogin = this.hideLogin.bind(this);
    this.hideRegister = this.hideRegister.bind(this);
    this.showLogin = this.showLogin.bind(this);
    this.showRegister = this.showRegister.bind(this);
  }

  toggleDrawer = () => {
    this.setState({ isDrawerOpen: !this.state.isDrawerOpen });
  };
  handleMenuItemClick = (clickedItem) => {
    if (["login", "sign-up", "ihopa-for-busineess"].indexOf(clickedItem) === -1) {
      this.props.navigate(`/${clickedItem}`);
    }
    if (clickedItem === "login") {
      this.showLogin();
    }
    if (clickedItem === "sign-up") {
      this.showRegister();
    }
    if (clickedItem === "ihopa-for-busineess") {
      window.location.href = "https://blog.ihopa.com/partner/";
    }
  };
  showLogin() {
    ReactGA.event({
      category: "User",
      action: "Has seen login form",
    });
    this.setState({ showLoginDialog: true });
  }
  showRegister() {
    ReactGA.event({
      category: "User",
      action: "Has seen register form",
    });
    this.setState({ showRegisterDialog: true });
  }
  hideLogin() {
    this.setState({ showLoginDialog: false });
  }
  hideRegister() {
    this.setState({ showRegisterDialog: false });
  }
  render() {
    const menuItems = [
      // {
      //   label: I18n.t("menu.search"),
      //   slug: "search",
      //   icon: "search"
      // },
      {
        label: I18n.t("menu.why_co_own"),
        slug: "why-co-own",
        icon: "endorsed",
      },
      { label: I18n.t("menu.about_us"), slug: "about-us", icon: "office" },
      { label: I18n.t("menu.ihopa_for_business"), slug: "ihopa-for-busineess", icon: "briefcase" },
      { label: I18n.t("menu.login"), slug: "login", icon: "unlock" },
    ];

    return (
      <nav>
        <Navbar fixedToTop={true} className="app-navbar">
          <Login
            isOpen={this.state.showLoginDialog}
            onClose={this.hideLogin}
            redirectTo="/dashboard"
            onRegisterClick={(_) => {
              this.hideLogin();
              this.showRegister();
            }}
          />
          <Register
            isOpen={this.state.showRegisterDialog}
            onClose={this.hideRegister}
            redirectTo="/dashboard"
            onLoginClick={(_) => {
              this.hideRegister();
              this.showLogin();
            }}
          />
          <div className="main-container flex-center-space-between">
            <Navbar.Group>
              <Navbar.Heading>
                <Link to="/">
                  <span className="app-logo" />
                </Link>
              </Navbar.Heading>
            </Navbar.Group>
            <Navbar.Group className="menu-right-side">
              <LanguageSelector />
              <div className="desktop-menu">
                <MainNavItems
                  items={menuItems}
                  selected={this.props.currentPage}
                  onItemClick={this.handleMenuItemClick}
                />
              </div>
              <div className="menu-trigger" onClick={this.toggleDrawer}>
                <Icon icon="menu" className="icon" />
              </div>
              <Drawer
                onClose={this.toggleDrawer}
                autoFocus={true}
                canEscapeKeyClose={true}
                canOutsideClickClose={true}
                enforceFocus={true}
                isOpen={this.state.isDrawerOpen}
                title={<span className="app-logo" />}
                usePortal={true}
                isCloseButtonShown={true}
                size="300px"
                className="menu-drawer">
                <div className="drawer-content">
                  <MainNavItems
                    items={menuItems}
                    selected={this.props.currentPage}
                    onItemClick={this.handleMenuItemClick}
                  />
                  <div className="drawer-footer">
                    <div className="legal-links">
                      <a href="/terms-of-use" className="small-link">
                        <Translate value="menu.terms_of_use" />
                      </a>
                      <a href="/privacy-policy" className="small-link">
                        <Translate value="menu.privacy_policy" />
                      </a>
                    </div>
                    <div className="social-links">
                      <a href="https://www.facebook.com/ihopadotcom" target="_blank" rel="noopener noreferrer" className="link facebook">
                        <CustomIcon name="facebook" className="icon" size="24" />
                      </a>
                      <a href="https://twitter.com/ihopa_com" target="_blank" rel="noopener noreferrer" className="link twitter">
                        <CustomIcon name="twitter" className="icon" size="24" />
                      </a>
                      <a href="https://www.linkedin.com/company/ihopa-com/" target="_blank" rel="noopener noreferrer" className="link linkedin">
                        <CustomIcon name="linkedin" className="icon" size="24" />
                      </a>
                    </div>
                  </div>
                </div>
              </Drawer>
            </Navbar.Group>
          </div>
        </Navbar>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  currentPage: state.router.location.pathname,
});
const mapDispatchToProps = (dispatch) => ({
  navigate: (to) => dispatch(navigate(to)),
});
export default connect(mapStateToProps, mapDispatchToProps)(PublicTopNav);
